import { render, staticRenderFns } from "./searchbar-1-component.vue?vue&type=template&id=b539d648&lang=html&"
import script from "./searchbar-1-component.vue?vue&type=script&lang=js&"
export * from "./searchbar-1-component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports